import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table } from "../../../features/Table";
import { type A6PdfPageSelection, columns } from "./columns";
import {
  type FilterA6PdfPageSelectionSchema,
  A6PdfPageSelectionFilter,
} from "./filter";

export const A6PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("tables");
  const client = searchParams.get("client") || "a6";
  const table_name = "a6_pdf_page_selection";

  return (
    <Table<A6PdfPageSelection, FilterA6PdfPageSelectionSchema>
      label={t("a6_pdf_page_selection.title", { defaultValue: "PDF page selection" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<A6PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
